import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { ChartContainerDataSet } from "models/propTypes/chartProps";
import { ChartEnums, InvoiceEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const InvoiceStatusDistributionDoughnutChart: React.FC = () => {
  const invoiceService = useInvoiceService();
  const invoiceWidgetTranslationPrefix = "Invoice.WidgetState_";


  const formatData = (chartData?: WintSuperkollAPIModel.ReportWidget): ChartContainerDataSet[] => {
    const data = chartData?.data;

    const result = EnumHelper.getNumericItemValues(InvoiceEnums.InvoiceViewChartState).map(
      (i): ChartContainerDataSet => ({
        label: LocalizationHelperInstance.getFormattedMessage(
          `${invoiceWidgetTranslationPrefix}${i as InvoiceEnums.InvoiceViewChartState}`
        ),
        data:
          data
            ?.filter((d) => invoiceService.toViewState(Number(d.name)) === (i as InvoiceEnums.InvoiceViewChartState))
            ?.map((i) => (i.dataPoints ? i.dataPoints[0] : 0))
            .reduce((prev: number, current: number, index, arr: number[]) => prev + current, 0) ?? 0,
        isNotSelected: i === InvoiceEnums.InvoiceViewChartState.Paid,
      })
    );
    return result;
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.InvoiceStatusDistribution}
      chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.StatusGraphTitle)}
      filterToAPIHandler={invoiceService.reportToAPIFilter}
      apiToChartHandler={formatData}
      doughnutChartLegendType={ChartEnums.LegendType.WITH_VALUES}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.INVOICE_STATUS}
      usePageFilter={false}
      useClickableChart
      onDataPointClickedSetFilter={(label?: any) => {
        const clickedLabel = typeof label === "string" ? label : undefined;
        const matchedState = EnumHelper.getNumericItemValues(InvoiceEnums.InvoiceViewChartState).find((i) => {
          const localized = LocalizationHelperInstance.getFormattedMessage(
            `${invoiceWidgetTranslationPrefix}${i as InvoiceEnums.InvoiceViewChartState}`
          );
          return localized === clickedLabel;
        }) as InvoiceEnums.InvoiceViewChartState | undefined;
        return matchedState !== undefined && matchedState >= 0
          ? {
              invoiceStatuses: [
                {
                  id: invoiceService.toApiState(matchedState),
                  value: LocalizationHelperInstance.getFormattedMessage(
                    `${invoiceWidgetTranslationPrefix}${matchedState as InvoiceEnums.InvoiceViewChartState}`
                  ),
                },
              ],
            }
          : {};
      }}
      onBackgroundClickedSetFilter={{ invoiceStatuses: [] }}
    />
  );
};

export default InvoiceStatusDistributionDoughnutChart;
